import React from "react";

export const thirdPartyReferralsConfig = [
  {
    auth: ["user"],
    routes: [
      {
        path: "/thirdparty-referral",
        component: React.lazy(() => import("./AppReferralsList")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/view-referral",
        component: React.lazy(() => import("./ViewReferrals")),
      },
    ],
  },
];